<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="propertySettings.title"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page app-content-page__settings">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="propertySettings.title"></app-i18n>
      </h1>

      <el-row :gutter="20">
        <el-col v-for="setting in settings" :key="setting.id" :lg="8" :md="12" :sm="24" class="item">
          <el-card>
            <div class="clearfix">
            <font-awesome-icon :icon="setting.icon" size="2x" class="settings-icon"/>
              <span class="text">{{ setting.title }}</span>
            </div>
            <div>
              <p>{{ setting.subtitle }}</p>
            </div>
          </el-card>
        </el-col>
      </el-row>

    </div>

  </div>
</template>

<script>
import { PropertySettingsModel } from '@modules/property-settings/property-settings-model';
const { settings } = PropertySettingsModel;

export default {
  computed: {
    settings() {
      return settings;
    },
  },

  methods: {
  },
};
</script>

<style>
  .text {
    font-size: 20px;
  }

  .item {
    margin-bottom: 18px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .settings-icon {
    padding-right: 10px;
  }
</style>

